/**
 * MAKjust Core
 * MAKjust核心请求类。
 */
import axios from 'axios';
import md5 from './md5';

const API_BASE_URL = 'https://api-lcs.makjust.com';
const ENG_BASE_URL = 'https://engine-lcs.makjust.com'
var API_BASE_HEADER = {
    'X-LC-Id': 'WePS2BEENiWviqeQ9BFxxXiX-gzGzoHsz',
    'X-lc-Sign': sign(),
    'Content-Type': 'application/json',
}

function sign() {
    let t = new Date().getTime();
    let key = md5["\x68\x65\x78\x5f\x6d\x64\x35"](t + '\x73\x6f\x36\x45\x79\x32\x75\x46\x76\x35\x66\x38\x75\x6a\x41\x68\x55\x69\x4a\x44\x46\x73\x32\x77');
    return `${key},${t}`;
}

function pwdhash(p) {
    return `$p${md5["\x62\x36\x34\x5f\x6d\x64\x35"](md5["\x68\x65\x78\x5f\x6d\x64\x35"]('\x28\x40\x3d\x2d\x3d\x5f\x40' + p + '\x29\x28\x30\x2e\x30\x3f\x40\x2e\x40\x21\x51\x57\x51\x7e\x7e') + "\x24\x28\x23\x2d\x3e\x6d\x6a\x70\x68\x76\x31\x3c\x3c\x40")}@`
}

function authHash(p) {
    //the password hash used in authme.
    /**
     * --PHP Version(CODE):
     * function generateRandomString( $length = 10 ) {
     *      $characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
     *      $randomString = '';
     *      for ( $i = 0; $i < $length; $i++ ) {
     *          $randomString .= $characters[ rand( 0, strlen( $characters ) - 1 ) ];
     *      }
     *      return $randomString;
     *  }
     * $salt = generateRandomString( 16 );
     * $password = '$SHA$' . $salt . '$' . hash( "SHA256", hash( "SHA256", $_POST[ "password" ] ) . "$salt" );
     * ///////////
     * --PRINCIPLE:
     * passwordHash = `$SHA` + randomString + `$` + SHA256(SHA256(password + randomString))
     * --PROBLEM:
     * NO install sha256 component. and lazy.^ ^
     */
}

const mjp = {
    init() {
        return axios.get(`${API_BASE_URL}/1.1/classes/web_options?keys=-objectId,-createdAt,-updatedAt`, { headers: API_BASE_HEADER })
    },
    async getBanner() {
        return axios.get(`${API_BASE_URL}/1.1/classes/banner?keys=-objectId,-createdAt,-updatedAt`, { headers: API_BASE_HEADER })
    },
    // MCBBS改版
    // async getNewsAsync() {
    //     return axios.get("https://api.lonay.me/1/mcs/mcbbsnews");
    // },
    async getAnnouncements() {
        return axios.get(`${API_BASE_URL}/1.1/classes/announcements?keys=-objectId,-updatedAt`, { headers: API_BASE_HEADER })
    },
    async getNotice() {
        return axios.get(`${API_BASE_URL}/1.1/classes/notice?keys=-objectId,-updatedAt`, { headers: API_BASE_HEADER })
    },
    async getMe(session) {
        API_BASE_HEADER['X-LC-Session'] = session
        return axios.get(`${API_BASE_URL}/1.1/users/me`, { headers: API_BASE_HEADER })
    },
    /**
     * 登录
     *
     * @param {String} email 用户邮箱
     * @param {String} password 用户密码（未Hash）
     * @returns
     */
    async login(email, password) {
        return axios.post(`${API_BASE_URL}/1.1/login`, { email: email, password: pwdhash(password) }, { headers: API_BASE_HEADER })
    },
    /**
     * OAuth通用链接
     *
     * @param {Object} authData AUTH返回的字段。格式为"{auth平台[qq/wechat]: {...data}}"
     * @returns
     */
    async authLogin(authData) {
        return axios.post(`${API_BASE_URL}/1.1/users`, {authData}, { headers: API_BASE_HEADER })
    },
    async bindOAuth(authData, sessionKey, objectId){
        API_BASE_HEADER['X-LC-Session'] = sessionKey
        return axios.put(`${API_BASE_URL}/1.1/users/${objectId}`, {authData}, { headers: API_BASE_HEADER })
    },
    async signup(username, email, password) {
        return axios.post(`${API_BASE_URL}/1.1/users`, { username: username, userfullid: username.toUpperCase(), email: email, "password": pwdhash(password) }, { headers: API_BASE_HEADER })

    },
    async getDonors() {
        return axios.get(`${API_BASE_URL}/1.1/classes/donors?keys=-objectId,-createdAt,-updatedAt`, { headers: API_BASE_HEADER })
    },
    getStatus(serverName = 'makjust') {
        let reData = Array;
        axios
            .get("https://api.lonay.me/1/mcs/status?service=" + serverName)
            .then(function (res) {
                //console.log(res.data);
                if (res.data.max_players) {
                    reData = {
                        status: 1,
                        max_players: res.data.max_players,
                        players: res.data.players
                    }
                } else {
                    reData = {
                        status: 0,
                        message: 'Server down.',
                    }
                }
            })
            .catch(function (error) {
                reData = {
                    status: 0,
                    message: '[Network error]' + error,
                }
            });
        return reData;
    },
    /**
     * @param {String} username 用户名或邮箱
     * @param {String} sessionKey 如果是查询自身信息，则需要携带sessionKey，并且会展示完整信息。
     */
    async getUserInformations(username, sessionKey = '') {
        let userInfo;
        if (sessionKey) {
            API_BASE_HEADER['X-LC-Session'] = sessionKey
        }
        //获取基本信息
        await axios.post(`${ENG_BASE_URL}/1.1/functions/getUserSpace`, { uid: username, session: sessionKey }, { headers: API_BASE_HEADER })
            .then((res) => {
                userInfo = res.data.result
            })
        return userInfo
    },
    //UP
    async updates(objId, session, datas) {
        let success;
        API_BASE_HEADER['X-LC-Session'] = session;
        await axios.put(`${API_BASE_URL}/1.1/users/${objId}`, datas, { headers: API_BASE_HEADER })
            .then(res => {
                success = [true]
            })
            .catch(err => {
                let msg;
                if (err.response.data.code === 137)
                    msg = '用户名已存在。'
                success = [false, msg]
            })
        return success;
    },
    async findPassword(objId, session, old_pwd, new_pwd) {
        let success;
        API_BASE_HEADER['X-LC-Session'] = session;
        await axios.put(`${API_BASE_URL}/1.1/users/${objId}/updatePassword`, {
            "old_password": pwdhash(old_pwd),
            "new_password": pwdhash(new_pwd)
        }, { headers: API_BASE_HEADER })
            .then(res => {
                success = true
            })
            .catch(err => {
                success = false
            })
        return success;
    }
}

export default mjp;
